import { Button, FormField, Input } from "@wix/design-system";
import React, { useContext, useRef, useState } from "react";
import { fetchOembedWithAuth } from "./../../wix-ricos-common/fetchEmbedData.js";
import { generateId, RICOS_VIDEO_TYPE, VIDEO_TYPE } from "./../../ricos-content/index.js";
import { DevContext, EditorContext, RicosContext } from "./../../ricos-context/index.js";
import { containsUrl } from "./../../_shared/link/contains-url.js";
import { useRequestService } from "./../../_shared/request-service-provider/request-service-provider.js";
import { ReactPlayer } from "./../../wix-react-player/index.js";
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from "./../../wix-rich-content-common/index.js";
import { EMBED_TAB_SUBMIT_BUTTON, EMBED_TAB_URL_INPUT } from "../data-hooks.js";
import classes from "./embed-video-scss.js";
import { isVideoMetadata } from "./is-video-metadata.js";
const EmbedVideo = ({
  componentData,
  helpers,
  closeModal,
  logBi,
  ...props
}) => {
  const { makeRequest } = useRequestService();
  const { t } = useContext(RicosContext);
  const { getPublicCommands } = useContext(EditorContext);
  const { fetchOembedWithAuthFromDevContext } = useContext(DevContext);
  const [url, setUrl] = useState(
    componentData?.video?.src?.id ? "" : componentData?.video?.src?.url || ""
  );
  const [submittedInvalidUrl, setSubmittedInvalidUrl] = useState(false);
  const inputRef = useRef(null);
  const onUrlUploadClick = () => {
    helpers.onPluginsPopOverClick?.({
      pluginId: RICOS_VIDEO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
    });
    logBi({ dataHook: EMBED_TAB_SUBMIT_BUTTON });
    if (!url || !ReactPlayer.canPlay(url)) {
      setSubmittedInvalidUrl(true);
      inputRef.current?.focus();
      return;
    }
    const videoData = (() => {
      const updatedVideo = { ...componentData.video, src: { url } };
      return props.nodeId ? { containerData: componentData.containerData, video: updatedVideo } : { ...componentData, video: updatedVideo };
    })();
    const nodeId = props.nodeId || generateId();
    const onVideoSelected = async (url2) => {
      try {
        const oembed = await fetchOembedWithAuthFromDevContext?.(url2) || await fetchOembedWithAuth(url2, makeRequest);
        if (!oembed || !isVideoMetadata(oembed) || typeof oembed !== "object") {
          console.error("Failed to fetch video oembed", oembed);
          return;
        }
        getPublicCommands().updateBlock?.(nodeId, RICOS_VIDEO_TYPE, {
          thumbnail: {
            src: { url: oembed.thumbnail_url },
            width: oembed.thumbnail_width,
            height: oembed.thumbnail_height
          },
          title: oembed.title
        });
      } catch (e) {
        console.error("Failed to fetch video oembed", e);
        return;
      }
    };
    setTimeout(() => {
      props.nodeId === void 0 ? getPublicCommands().insertBlockWithBlankLines(VIDEO_TYPE, {
        ...videoData,
        id: nodeId
      }) : getPublicCommands().setBlock(props.nodeId, RICOS_VIDEO_TYPE, videoData);
      onVideoSelected(url);
    });
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormField,
    {
      label: t("VideoModal_Embed_Title"),
      maxLines: 2,
      status: submittedInvalidUrl ? "error" : void 0,
      statusMessage: submittedInvalidUrl ? t("SoundCloudUploadModal_Input_InvalidUrl") : void 0
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        inputRef: (ref) => {
          inputRef.current = ref;
        },
        className: classes.input,
        type: "url",
        id: "dropdown-text-input",
        autocomplete: "off",
        dataHook: EMBED_TAB_URL_INPUT,
        value: url,
        textOverflow: "ellipsis",
        onChange: (e) => {
          setSubmittedInvalidUrl(false);
          setUrl(e.target.value);
          logBi({ dataHook: EMBED_TAB_URL_INPUT, value: e.target.value });
        },
        placeholder: t("EmbedURL_Placeholder"),
        onBlur: () => {
          if (url && !containsUrl(url)) {
            setSubmittedInvalidUrl(true);
          }
        },
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            onUrlUploadClick();
          }
        }
      }
    )
  ), /* @__PURE__ */ React.createElement(Button, { dataHook: EMBED_TAB_SUBMIT_BUTTON, onClick: onUrlUploadClick, size: "small" }, t("VideoModal_Embed_ButtonText")));
};
export {
  EmbedVideo
};
//# sourceMappingURL=embed-video.js.map
